import {
  entityService,
  eventService,
  eventRestrictionsService,
  eventTypesService,
  userService,
  userEventsService,
  exhibitorEventsService,
} from '@/services'

import { EntityNames } from '@/controllers/EntityNames'

export const LoadEvents = {
  async getEvents() {
    try {
      return await eventService.getEvents()
    } catch (e) {
      return e
    }
  },

  async getEventLangAll() {
    try {
      return await eventService.getEventLangAll()
    } catch (e) {
      return e
    }
  },

  async getStatus(id) {
    try {
      return await entityService.getEntityId(id)
    } catch (e) {
      return e
    }
  },

  async getType(id) {
    try {
      return await eventTypesService.getTypeId(id)
    } catch (e) {
      return e
    }
  },

  async getRestrictionsId(id) {
    try{
      return await eventRestrictionsService.getEventRestrictionId(id)
    } catch (e) {
      return e
    }
  },

  async getUserId() {
    try {
      return await userService.getUserId()
    } catch (e) {
      return e
    }
  },

  async getUserEventsAll(id) {
    try {
      return await userEventsService.getUserEventsAll(id)
    } catch(e) {
      return e
    }
  },

  async getExhibitorEventsAll(id) {
    try {
      return await exhibitorEventsService.getExhibitorEventsAll(id)
    } catch(e) {
      return e
    }
  },

  async updateEvent(value, status) {
    let payload = value.sourceItem
    console.log('payload',payload)
    payload.status = status.id

    try {
      let resp = await eventService.editEvent(payload)
      console.log('updating ExhibitorEvent successful', resp)

      return true
    }
    catch (e) {
      console.log('updating ExhibitorEvent thrown an error', e)
      console.log('payload that thrown an error', payload)

      return e
    }
  },

  async getNotificationsData() {
    let eventsResponseLangAll = await this.getEventLangAll()

    let obj = [];

    let getIdUser = await this.getUserId()
    let getUserEvent = await this.getUserEventsAll(getIdUser)
    let getExhibitorEvent = await this.getExhibitorEventsAll(getIdUser)

    for (const [index, item]  of Object.entries(eventsResponseLangAll)) {
      let itemEvent = Object.assign({}, item);
      let type = await this.getType(itemEvent.type);
      let restriction = await this.getRestrictionsId(itemEvent.restriction)
      let status = await this.getStatus(itemEvent.status);
      itemEvent.visitorStatus = 'want-go'
      itemEvent.visitorId = null
      //
      itemEvent.exhibitorStatus = 'became'
      itemEvent.exhibitorId = null

      for(const [index, itemExhibitorEvent] of Object.entries(getExhibitorEvent)) {
        if (itemExhibitorEvent.event === item.id) {
          itemEvent.exhibitorStatus = await EntityNames.getStatus(itemExhibitorEvent.status)
          itemEvent.exhibitorId = getExhibitorEvent[index].id
        }
      }
      for(const [index, itemUserEvent] of Object.entries(getUserEvent)) {
        if (itemUserEvent.event === item.id) {
          itemEvent.visitorStatus = await EntityNames.getStatus(itemUserEvent.status)
          itemEvent.visitorId = getUserEvent[index].id
        }
      }
      itemEvent.status = status.name;
      itemEvent.type = type.name;
      itemEvent.restriction = restriction.name
      obj.push(itemEvent);

    }
    return obj
  },

  async getFullAdminData(userEvent = true, exhibitorEvent = true) {
    let eventsResponseLangAll = await this.getEventLangAll()
    //let eventsResponse = await this.getEvents();

    let obj = [];

    let getIdUser = await this.getUserId()
    let getUserEvent = await this.getUserEventsAll(getIdUser)
    let getExhibitorEvent = await this.getExhibitorEventsAll(getIdUser)

    for (const [index, item]  of Object.entries(eventsResponseLangAll)) {

      //console.log(index)
      await Promise.all(item.translations.map(async (elem, idx) => {
          let itemEvent = Object.assign({}, item);
          if(item.translations[idx].description) {
            let status = await this.getStatus(itemEvent.status);
            let type = await this.getType(itemEvent.type);
            let restriction = await this.getRestrictionsId(itemEvent.restriction)
            //
            //console.log(elem.description)
            itemEvent.visitorStatus = 'want-go'
            itemEvent.visitorId = null
            //
            itemEvent.exhibitorStatus = 'became'
            itemEvent.exhibitorId = null
            //
            itemEvent.description = item.translations[idx].description
            itemEvent.name = item.translations[idx].name
            itemEvent.locale = item.translations[idx].locale

            //itemEvent.description = eventsResponseLangAll[index+idx].translations[idx].description
            //
            if(exhibitorEvent === true) {
              for(const [index, itemExhibitorEvent] of Object.entries(getExhibitorEvent)) {
                if (itemExhibitorEvent.event === item.id) {
                  itemEvent.exhibitorStatus = await EntityNames.getStatus(itemExhibitorEvent.status)
                  itemEvent.exhibitorId = getExhibitorEvent[index].id
                }
              }
            }
            if(userEvent === true) {
              for(const [index, itemUserEvent] of Object.entries(getUserEvent)) {
                if (itemUserEvent.event === item.id) {
                  itemEvent.visitorStatus = await EntityNames.getStatus(itemUserEvent.status)
                  itemEvent.visitorId = getUserEvent[index].id
                }
              }
            }
            itemEvent.status = status.name;
            itemEvent.type = type.name;
            itemEvent.restriction = restriction.name
            obj.push(itemEvent);
          }

        })
      )
      //

    }


    return obj
  },
  //
  async getFullData(userEvent = true, exhibitorEvent = true) {
    let eventsResponseLangAll = await this.getEventLangAll()
    //let eventsResponse = await this.getEvents();

    let obj = [];

    let getIdUser = await this.getUserId()
    let getUserEvent = await this.getUserEventsAll(getIdUser)
    let getExhibitorEvent = await this.getExhibitorEventsAll(getIdUser)

    for (const [index, item]  of Object.entries(eventsResponseLangAll)) {

      //console.log(index)
      await Promise.all(item.translations.map(async (elem, idx) => {
          let itemEvent = Object.assign({}, item);
          if(item.translations[idx].description) {
            let status = await this.getStatus(itemEvent.status);
            let type = await this.getType(itemEvent.type);
            let restriction = await this.getRestrictionsId(itemEvent.restriction)
            //
            //console.log(elem.description)
            itemEvent.visitorStatus = 'want-go'
            itemEvent.visitorId = null
            //
            itemEvent.exhibitorStatus = 'became'
            itemEvent.exhibitorId = null
            //
            itemEvent.description = item.translations[idx].description
            itemEvent.name = item.translations[idx].name
            itemEvent.locale = item.translations[idx].locale

            //itemEvent.description = eventsResponseLangAll[index+idx].translations[idx].description
            //
            if(exhibitorEvent === true) {
              for(const [index, itemExhibitorEvent] of Object.entries(getExhibitorEvent)) {
                if (itemExhibitorEvent.event === item.id) {
                  itemEvent.exhibitorStatus = await EntityNames.getStatus(itemExhibitorEvent.status)
                  itemEvent.exhibitorId = getExhibitorEvent[index].id
                }
              }
            }
            if(userEvent === true) {
              for(const [index, itemUserEvent] of Object.entries(getUserEvent)) {
                if (itemUserEvent.event === item.id) {
                  itemEvent.visitorStatus = await EntityNames.getStatus(itemUserEvent.status)
                  itemEvent.visitorId = getUserEvent[index].id
                }
              }
            }
            itemEvent.status = status.name;
            itemEvent.type = type.name;
            itemEvent.restriction = restriction.name
            obj.push(itemEvent);
          }

      })
      )
      //

    }


    return obj
  },

}